/* Spanish catalog mirroring locale-invoice-list-control-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'listControl.dialog': 'Cierra el diálogo abierto antes de que el chat continúe con la lista de facturas.',
  'live.set_document_type': 'Seleccionando el tipo de documento …',
  'listControl.alreadyDone': 'Esta operación ya se completó para este documento en la solicitud actual.',
  'listControl.choice.attachment': 'Adjunto en PDF',
  'listControl.choice.link': 'Enlace',
  'listControl.choice.reminder': 'Recordatorio de pago',
  'listControl.choice.purring': 'Recordatorio',
  'listControl.working': 'Trabajando con la lista de facturas …',
  'listControl.unavailable': 'La lista de facturas no está lista. Abre la página e inténtalo de nuevo.',
  'listControl.selection': 'Selecciona resultados de búsqueda inequívocos, como máximo 20 documentos a la vez.',
  'listControl.changed': 'La lista o la selección cambió. Busca y selecciona de nuevo.',
  'listControl.invalid': 'Faltan detalles válidos de la acción.',
  'listControl.ineligible': 'Esta acción no está disponible para todos los documentos seleccionados.',
  'listControl.reason': 'Indica el motivo de la nota de crédito.',
  'listControl.reminder': 'Elige una factura pendiente, el tipo de recordatorio y la nueva fecha de vencimiento. No se añade ningún recargo.',
  'listControl.payment': 'Indica un importe dentro del saldo pendiente, la fecha de pago y la cuenta de una factura.',
  'listControl.conversion': 'Selecciona un presupuesto emitido sin conversiones previas. Usa Crear en la página para una conversión adicional.',
  'listControl.uncertain': 'El resultado no está confirmado. Comprueba el documento antes de reintentar; el chat no lo reintentará automáticamente.',
  'listControl.unsaved': 'Guarda o cierra el borrador abierto antes de cambiar de documento.',
  'listControl.stopped': 'No se procesó el resto de la selección.',
  'listControl.done.searched': 'La búsqueda es visible en la lista de facturas.',
  'listControl.done.selected': 'Los documentos están seleccionados en la lista.',
  'listControl.done.opened': 'El documento está abierto.',
  'listControl.done.unsaved': 'El borrador está abierto y todavía no se ha guardado.',
  'listControl.done.prepared': 'La acción y los detalles se muestran abajo.',
  'listControl.done.sent': 'Enviado.',
  'listControl.done.paid': 'Pago registrado.',
  'listControl.done.deleted': 'Borrador eliminado.',
  'listControl.done.archived': 'Archivado.',
  'listControl.done.restored': 'Restaurado desde el archivo.',
  'listControl.done.creditDraft': 'Nota de crédito guardada como borrador.',
  'listControl.done.issued': 'Documento emitido.',
  'listControl.operation.send': 'Enviar documentos',
  'listControl.operation.reminder': 'Enviar recordatorio sin recargo',
  'listControl.operation.credit': 'Abonar',
  'listControl.operation.archive': 'Archivar',
  'listControl.operation.restore': 'Restaurar',
  'listControl.operation.delete_draft': 'Eliminar borradores',
  'listControl.operation.register_payment': 'Registrar pago',
  'listControl.operation.issue_draft': 'Emitir documento',
  'listControl.option.recipientEmail': 'Destinatario',
  'listControl.option.deliveryMode': 'Envío',
  'listControl.option.variant': 'Tipo',
  'listControl.option.dueDate': 'Fecha de vencimiento',
  'listControl.option.comment': 'Comentario',
  'listControl.option.creditReason': 'Motivo',
  'listControl.option.issue': 'Emitir la nota de crédito completada',
  'listControl.option.amount': 'Importe',
  'listControl.option.date': 'Fecha de pago',
  'listControl.option.settlementAccountCode': 'Cuenta de pago',
  'listControl.option.note': 'Nota',
  'live.done.set_document_type': 'Tipo de documento seleccionado.',
});
